
<template>
  <div class="white-container marginTop">
    <p class="mb10 f500">上传图片</p>
    <div class="upload-box">
      <div class="upload-box-left">
        <div v-if="!imgInfo.sourceUrl">
          <el-button class="add-btn upload-img-btn" icon="el-icon-plus">
            <input accept="image/jpg,image/png,image/jpeg" type="file" class="upload-img-input" @change="handleUploadImg">
          </el-button>
          <p class="upload-img-tips">支持上传*.JPG、PNG*大小不超过5M，尺寸：宽度750高度不限制</p>
        </div>
        <div v-if="imgInfo.sourceUrl">
          <img class="img-ele" :src="imgInfo.sourceUrl" alt="uploadimg">
          <div class="change-img-tips-box">
            <div class="change-img-txt-box">
              <span>更换图片</span>
              <input accept="image/jpg,image/png,image/jpeg" type="file" class="upload-img-input" @change="handleUploadImg">
            </div>
            <p class="upload-img-tips">支持上传*.JPG、PNG*大小不超过5M，尺寸：宽度750高度不限制</p>
          </div>
        </div>
        <div class="label-box">
          <p>链接地址</p>
          <el-input v-model="imgInfo.jumpLink" class="label-input" placeholder="请输入链接地址" @change="handleUploadInfo" />
        </div>
      </div>
      <p class="label-delete" @click="delComponent">删除</p>
    </div>
    <div class="cfg-btn-box">
      <div class="label-box">
        <p>消息模版ID</p>
        <el-input v-model="imgInfo.subscribeId" class="label-input" placeholder="请输入消息模版ID" @change="handleUploadInfo" />
      </div>
      <div class="label-box">
        <el-popover
          placement="bottom-start"
          title="【moduleName】+【_】+【根据UI显示的按钮文案配置】"
          width="440"
          trigger="hover"
          content=""
        >
          <el-button slot="reference" icon="el-icon-info" class="btn-name">btnName</el-button>
        </el-popover>
        <el-input v-model="imgInfo.sensorsData.btnName" class="label-input" placeholder="请输入btnName" @change="handleUploadInfo" />
      </div>
      <div class="label-box">
        <el-popover
          placement="bottom-start"
          title="根据UI显示的模块标题文案配置，两个系统模块拼接成一个UI模块的，同一个UI模块取相同的系统模块名称"
          width="440"
          trigger="hover"
          content=""
        >
          <el-button slot="reference" icon="el-icon-info" class="btn-name">moduleName</el-button>
        </el-popover>
        <el-input v-model="imgInfo.sensorsData.moduleName" class="label-input" placeholder="请输入moduleName" @change="handleUploadInfo" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UploadImg',
  props: {
    imgInfo: {
      type: Object,
      default: () => (
        { sourceUrl: '', jumpLink: '', sensorsData: { btnName: '', moduleName: '' }, subscribeId: '', cloudVideoId: null }
      ),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    delComponent() {
      this.$emit('del', this.index);
    },
    /* input 上传图片  */
    async handleUploadImg(e) {
      const file = e.target.files[0];
      const res = await this.checkImgInfo(file);
      if (res) {
        this.$Api.uploadFile.uploadImage(file, 'loyaltyCampaign/').then(data => {
          this.uploadLoading = false;
          this.imgInfo.sourceUrl = data;
          this.handleUploadInfo();
        });
        this.$message.success('图片上传成功');
        /* 删除input 中的值 */
        e.target.value = '';
      } else {
        e.target.value = '';
      }
    },
    async checkImgInfo(file) {
      try {
        const ALLOWED_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
        const MAX_SIZE = 5 * 1024 * 1024; // 5MB
        const REQUIRED_WIDTH = 750;
        if (!ALLOWED_TYPES.includes(file.type)) {
          this.$message.error('请上传 JPG 或 PNG 格式的图片');
          return false;
        }
        if (file.size > MAX_SIZE) {
          this.$message.error(`图片大小不能超过 ${MAX_SIZE / 1024 / 1024}M`);
          return false;
        }
        const dimensions = await this.getImageDimensions(file);
        if (dimensions.width !== REQUIRED_WIDTH) {
          this.$message.error(`图片宽度必须为 ${REQUIRED_WIDTH}px`);
          return false;
        }
        return true;
      } catch (error) {
        this.$message.error('图片验证失败：' + error.message);
        return false;
      }
    },
    getImageDimensions(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          URL.revokeObjectURL(img.src);
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = () => {
          URL.revokeObjectURL(img.src);
          reject(new Error('图片加载失败'));
        };
      });
    },
    handleUploadInfo() {
      this.$emit('uploadImg', { imgInfo: this.imgInfo, index: this.index });
    },
  },
};
</script>
<style lang="less" scoped>
  /deep/ .label-input .el-input__inner{
    height: 34px;
  }
  .f500{
    font-weight: 500;
  }
  .mb10{
    margin-bottom: 10px;
  }
  .marginTop {
    margin-top: 30px;
  }
  .upload-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 222px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 30px 44px;
    background: #f7f7f7;
    .upload-box-left{
      display: flex;
      align-items: center;
      gap: 60px;
    }
    .upload-img-tips{
      font-size: 12px;
      color: #bbb;
      margin-top: 5px;
      line-height: 1.2;
    }

    .label-delete{
      font-size: 14px;
      color: #0085D0;
      cursor: pointer;
      margin-right: 100px;
    }
    .change-img{
      font-size: 14px;
      color: #0085D0;
      cursor: pointer;
      margin: 10px 0;
    }
    .img-ele{
      width: 210px;
      height: 150px;
      border-radius: 4px;
      object-fit: cover;
    }
    .change-img-tips-box{
      display: flex;
      align-items: center;
      margin-top: 6px;
      flex-wrap: wrap;
      .change-img-txt-box{
        position: relative;
        color: #0085D0;
        cursor: pointer;
        margin-right: 15px;
        .upload-img-input{
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
        }
        .change-img-btn{
          width: 110px;
          height: 38px;
        }
      }
    }
  }
  .add-btn{
    width: 150px;
    height: 34px;
    border: 1px dashed #9B9B9B;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }
  .upload-img-btn{
    position: relative;
    width: 210px;
    height: 150px;
    font-size: 30px;
    color: #bbb;
    background-color: transparent;
    .upload-img-input{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
  .label-box{
    display: flex;
    align-items: center;
    min-width: 432px;
    font-size: 14px;
    .label-input{
      width: 360px;
      margin-left: 4px;
    }
    .btn-name{
      border: none;
      padding: 0;
    }
    .btn-name:hover{
      background: none;
    }
  }
  .cfg-btn-box{
    display: flex;
    align-items: center;
    gap:30px;
    flex-wrap: wrap;
  }
</style>
